<!--Copyright 2022 The Casdoor Authors. All Rights Reserved.-->

<!--Licensed under the Apache License, Version 2.0 (the "License");-->
<!--you may not use this file except in compliance with the License.-->
<!--You may obtain a copy of the License at-->

<!--     http://www.apache.org/licenses/LICENSE-2.0 -->

<!--Unless required by applicable law or agreed to in writing, software-->
<!--distributed under the License is distributed on an "AS IS" BASIS,-->
<!--WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.-->
<!--See the License for the specific language governing permissions and-->
<!--limitations under the License.-->

<template>
 <h1>Link Tiltify</h1>
</template>

<script>
import * as config from "@/config";

export default {
 name: "linkPage",
 mounted() {
  this.getUserInfo()
 },
 methods: {
  getUserInfo() {
   fetch(`${config.serverUrl}/link/tiltify`, {
    method: 'GET',
    headers: {
     'CF-Access-Client-Id': `${config.cloudflare_client_id}`,
     'CF-Access-Client-Secret': `${config.cloudflare_client_secret}`
    }
   }).then(res => {
    res.json().then(data => {
     console.log(JSON.stringify(data))
     let user = JSON.parse(localStorage.getItem(user) || "{}");
     console.log('User: ', user);
     data.email = user.email;
     return data;
     // localStorage.setItem('user', JSON.stringify(data));
     // window.location.href = "/home";
    });
   });
  },
 },
}
</script>

<style scoped></style>
